import { useState, useEffect } from 'react';

function useIsKeyHeld(key) {
  const [isHeld, setIsHeld] = useState(false);
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      return;
    }
    const abortController = new AbortController();
    const { signal } = abortController;
    window.addEventListener("keydown", (event) => {
      if (event.key === key) {
        setIsHeld(true);
      }
    }, { signal });
    window.addEventListener("keyup", (event) => {
      if (event.key === key) {
        setIsHeld(false);
      }
    }, { signal });
    window.addEventListener("blur", () => {
      setIsHeld(false);
    }, { signal });
    return () => {
      abortController.abort();
    };
  }, [key]);
  return isHeld;
}

export { useIsKeyHeld };
//# sourceMappingURL=useIsKeyHeld.es.js.map
